import { GambitCategory, GambitChessSetPolicy, GambitRepeat, GambitType } from '@/core/data/gambit/gambit.type';
import type { BaseLocationDto, DetailLocationDto, GeoCoords } from '@/core/data/location/location.interface';
import type { CheckInDto } from '@/views/main/gambits/AttendeeList.vue';
import type { BaseClubDto } from '../club/club.interface';
import type { BaseUserDto } from '../user/user.interface';

export type { LiveGambitDto, RespondGambitDto } from '@/core/network/api/gambit/gambit.api';

export interface GambitDto extends BaseGambitDto {
  description?: string | null;

  createdAt: Date;
  updatedAt: Date;
}

export enum GambitSparkState {
  SPARKED = 'sparked',
  MATCHED = 'matched',
  CONFIRMED = 'confirmed',
  BOOKED = 'booked',
  COMPROMISED = 'compromised',
  ABANDONED = 'abandoned',
  SUCCEEDED = 'succeeded',
}

export interface BaseGambitDto {
  id: string;
  start: string;
  end: string;
  distance: number;
  gambitType: GambitType[];
  gambitCategory: GambitCategory;
  chessSetPolicy: GambitChessSetPolicy;
  locationPoint?: GeoCoords;
  blockedCount?: number;
  timed?: boolean;
  streamed?: boolean;
  title: string;
  clubId: string | null;
  repeat?: GambitRepeat;
  ownerId: string | null;
  parentId: string | null;
  locationImageBlobHash?: string | null;
  canEdit: boolean;
  isAttending: boolean;
  attendeeCount: number;
  minEloRating: number | null;
  maxEloRating: number | null;
  location?: BaseLocationDto | DetailLocationDto;
  isChallenge?: boolean;
  isSpark?: boolean;
  isConfirmed?: boolean;
  isEditedChallenge?: boolean;
  // sparkId: string | null;
  participantIds?: string[];
  sparkState?: GambitSparkState;
  hasUnreadChatMessages?: boolean;
}
export interface DetailGambitDto extends BaseGambitDto {
  club: BaseClubDto;
  user: BaseUserDto;
  attendeeChessSetCount: number;
  locationHasChessSets: boolean;
  locationChessSetCount: number | null;
  activeCheckIns: CheckInDto[];
  handshakeEligibleCheckIns: string[];
  recentCheckIns: string[];
}

export enum GambitAttendanceStatus {
  CONFIRMED = 'confirmed',
  SPARKED = 'sparked',
  CANCELED = 'canceled',
}

export interface BaseAttendanceDto {
  id: string;
  userId: string;
  gambitId: string;
  status: GambitAttendanceStatus;
  chessSetCount: number;
}

export interface GambitProposalSummaryDto {
  id: string;
  isSuccessful: boolean;
  date: string;
  confirmations: GambitProposalConfirmationSummaryDto[];
  isInvited?: boolean;
  cityId?: string;
  cityName?: string;
  cityCoordinates?: { lat: number; lng: number };
}

export interface GambitProposalConfirmationSummaryDto {
  id: string;
  userId: string;
  username?: string;
  rating?: number | null;
  profileImageBlobHash?: string | null;
  ratingDisplayMode?: string;
  meetAnywaysAt?: string | null;
}

export interface AttendeeAvatarDto {
  userId: string;
  username: string;
  rating?: number | null;
  profileImageBlobHash?: string | null;
  ratingDisplayMode?: string;
}

export interface LocationGambitDto {
  id: string;
  name: string;
  coordinates: GeoCoords;
  start: string;
  end: string;
  category: GambitCategory | null;
  proposal?: GambitProposalSummaryDto | null;
}

export interface GambitFormData {
  start?: string;
  end?: string;
  wallStart?: string;
  wallEnd?: string;
  utcStart?: string;
  utcEnd?: string;
  zonedStart?: string;
  zonedEnd?: string;
  locationId?: string;
  locationPoint?: GeoCoords;
  address?: string;
  chessSetPolicy: GambitChessSetPolicy;
  ownerChessSetCount?: number;
  gambitType: GambitType[];
  gambitCategory: GambitCategory;
  title: string;
  description?: string;
  timed: boolean;
  streamed: boolean;
  private: boolean;
  clubId: string | null;
  repeat?: GambitRepeat;
  repeatUntil?: string;
  isChallenge?: boolean;
  invitationUserIds?: string[];
}

export interface GambitRecurrenceOptions {
  recurrences?: boolean;
}

export interface SparkGambitOptions {
  // sparkId: SparkSlotId;
  title: string;
  day: number;
  startHour: number;
  endHour?: number;
  locationId?: string;
  googlePlaceId?: string;
  cityName: string;
  address: string;
  coordinates: { lat: number; lng: number };
  minConfirmations?: number;
  maxAttendees?: number;
}
